import React from 'react';
import { WarningBannerElement } from './styles';

interface WarningBannerProps {
  isFullBorder?: boolean;
  bannerText: string;
}

export const WarningBanner = ({
  bannerText,
  isFullBorder,
}: WarningBannerProps) => {
  return (
    <WarningBannerElement isFullBorder={isFullBorder}>
      <span>{bannerText}</span>
    </WarningBannerElement>
  );
};
